<div
  class="brn-form__select"
  [ngClass]="{ 'brn-form__select--white': style === 'white', 'brn-form__select--active': showOptionsContainer }"
  #formSelect
  (clickOutside)="hideOptions()"
  (focus)="showOptions()"
  tabindex="0"
>
  <div class="select__input" (click)="showOptions()">
    <p class="select__input-value" *ngIf="value">
      {{ label }}
    </p>
    <p class="select__input-placeholder" *ngIf="!value">
      {{ placeholder }}
    </p>
    <div class="select__suggest" *ngIf="showOptionsContainer && suggest">
      <input
        #formSuggest
        placeholder="Search..."
        type="text"
        [(ngModel)]="suggestValue"
      />
    </div>

    <i
      class="material-icons"
      [ngClass]="{ 'icon--active': showOptionsContainer }"
    >
      keyboard_arrow_down
    </i>
  </div>

  <div
    [ngClass]="{ 'brn-form__options-container--active': showOptionsContainer }"
    class="brn-form__options-container"
  >
    <div class="brn-form__options-list">
      <brn-form-option
        *ngFor="let option of options | suggest: suggestValue:'name'"
        [option]="option"
        [optionLabel]="optionLabel"
        [optionValue]="optionValue"
        [value]="value"
        (selectEvent)="select($event)"
      ></brn-form-option>
      <div
        class="brn-form__empty-option"
        *ngIf="!(options | suggest: suggestValue:'name').length && suggest"
      >
        <p>No matching...</p>
      </div>
    </div>
  </div>
  <div
    class="brn-form__options-container--pseudo"
    *ngIf="showOptionsContainer"
  ></div>
</div>
